import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { userAgentStringToPlatform } from 'helpers/UserAgentUtils';
import { SMS } from 'components/icons';

class SmsShare extends Component {
  static contextTypes = {
    testId: PropTypes.func
  };

  state = {
    separator: '?'
  };

  componentDidMount() {
    const platform = userAgentStringToPlatform();
    this.setState({ separator: (platform === 'iphone' || platform === 'ipad') ? '&' : '?' });
  }

  render() {
    const { separator } = this.state;
    const { product: { name, link }, className } = this.props;
    const { testId } = this.context;
    const smsLink = `sms:${separator}body=${name} ${link}`;

    return (
      <a
        href={smsLink}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        aria-label="Share via SMS"
        data-te="TE_PDP_SHARESMS"
        data-test-id={testId('smsShareIcon')}>
        <SMS size={22}/>
      </a>
    );
  }
}

export default SmsShare;
